import classNames from '@/common/utils/classNames';
import type { CorporateOrganization } from '../types';

/** The organization's logo at a given height, cropped to the mark inside its file (`logo.box`). */
export const OrganizationLogo = ({ organization, height, className }: { organization: CorporateOrganization; height: number; className?: string }) => {
  const { src, width, height: fileHeight, box } = organization.logo;
  const scale = height / fileHeight;
  return (
    <span
      role="img"
      aria-label={organization.name}
      className={classNames('relative inline-block shrink-0 overflow-hidden', className)}
      style={{ height, width: box.width * scale }}
    >
      <img
        src={src}
        alt=""
        className="absolute top-0 max-w-none"
        style={{ height, width: width * scale, left: -box.x * scale }}
      />
    </span>
  );
};
